import { render, staticRenderFns } from "./UsesForm.vue?vue&type=template&id=848f5a5a&"
import script from "./UsesForm.vue?vue&type=script&lang=js&"
export * from "./UsesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsesForm.vue"
export default component.exports